import { render, staticRenderFns } from "./CallTableSettingsActions.vue?vue&type=template&id=07995a3e"
import script from "./CallTableSettingsActions.vue?vue&type=script&lang=js"
export * from "./CallTableSettingsActions.vue?vue&type=script&lang=js"
import style0 from "./CallTableSettingsActions.vue?vue&type=style&index=0&id=07995a3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports